// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3XofU","image":"Header_image__17kYj","name":"Header_name__2aHTo","info":"Header_info__1bqw5","infoRow":"Header_infoRow__3HA-o"};